module.exports = __webpack_public_path__ + "img/centerD.94774322.png";